import { Component, Input } from '@angular/core';
import { Breadcrumbs } from 'src/app/shared/models/breadcrumbs';

@Component({
  standalone: false,
  selector: 'supplier-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent {
  @Input() items: Breadcrumbs[] = [];

  constructor() {}
}

